import {
  Toolbar as MuiToolbar,
  ColumnsPanelTrigger,
  GridToolbarExportContainer,
  GridCsvExportMenuItem,
} from '@mui/x-data-grid-pro';
import { Stack } from '@legacy/components/mui-components';
import { Tooltip } from '@mui/material';
import { ViewColumn } from '@mui/icons-material';

export const Toolbar = () => (
  <MuiToolbar>
    <Stack direction="row" justifyContent="flex-end">
      <Tooltip title="See columns">
        <ColumnsPanelTrigger>
          <ViewColumn fontSize="small" />
        </ColumnsPanelTrigger>
      </Tooltip>
      <GridToolbarExportContainer>
        <GridCsvExportMenuItem />
      </GridToolbarExportContainer>
    </Stack>
  </MuiToolbar>
);
